<template>
  <div class="orderList-container">
    <app-header            
        @on-click="goBack"
        :title="$t('digital.order.title')"
    ></app-header>
    <!-- 已购订单 -->
    <div class="digital-order">
      <div class="digital-order-list">
        <div class="digital-item" v-for="(item) in orderList" :key="item.orderId" @click="goToDetail(item)">
          <div class="digital-item-img">
            <img v-if="item.listImage" :src="item.listImage" alt="" />
            <img v-else class="no-item-img" src="../../assets/imgs/login/noCoupons.png" alt="" />
          </div>
          <div class="digital-item-info">
            <h3 class="van-ellipsis">{{item.goodsName}}</h3>
            <!-- <p class="van-multi-ellipsis--l2">{{item.describe}}</p> -->
          </div>
          <div class="digital-item-tip">{{ $t('digital.completed') }}</div>
        </div>
      </div>
        <div v-if="!orderList || orderList.length === 0" class="no-order">
            {{ $t('coupons.no_data') }}
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        orderList: [], // 订单列表
    };
  },
  mounted() {
    // 页面加载时获取订单列表
    this.getOrderList();
  },
  methods: {
        // 获取订单列表、
    getOrderList() {
        let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
        let url = '/bss/app/order/queryOrderListForApp';
        let reqParams = {
            customerId:urlData['loginCustomerId'],
            // categoryCode:"DIGITAL_PRODUCTS",
            goodsExtendAttrs:["hideFlowSize","detailRemark","detailImage",'iconImage','listImage','listImageSquare']
        };
    
        this.$http.post({
            url,
            data: {
                ...reqParams
            }
        }).then(res => {
            if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                this.orderList = res.data.dataList.map(item => {
                    // 处理商品价格格式
                    let goods = item.offerList[0] || {}
                    this.doPriceStyle(item, goods.goodsPrice, 'goodsPriceText');
                    let imgList = (goods.extendValVos || []).filter(val => val.attrCode === 'listImage').flatMap(val => val.attrValueList) || [];
                    
                    return {
                        ...item,
                        ...goods,
                        listImage:imgList[0] || '', // 列表图片
                        describe: goods.attrMap.pkDesc, // 商品描述
                    };
                });
                this.$nextTick(() => {
                    this.handleImageLoad(); // 设置图片高度
                });
            }
        }).catch(err => {
            this.$toast(err)
        });
    },
    // 动态设置图片高度
    handleImageLoad() {
        const ratio = 336 / 184; // 336:184 是图片的宽高比
        let ImgDomList = document.querySelectorAll('.digital-item-img') || [];
        ImgDomList.forEach((item) => {
            let width = item.offsetWidth;
            item.style.height = `${width / ratio}px`;
        });
    },
    doPriceStyle(item, price, key) {
        item[key] =  this.globalPriceFormat(item.currencyType, price);        
    },
    // 跳转到详情页
    goToDetail(item) {
      this.$router.push({
        name: "DigitalDetail",
        query: {
            goodsCode: item.goodsCode, // 商品编码
            categoryCode:item.categoryCode, // 商品分类编码
            souce:"产品订单列表",
        }, //
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.orderList-container {
  background-color: #f9fafb;
  min-height: 100vh;
  position: relative;
  font-family: sans-serif;
//   padding: 20px 15px 40px;

  .digital-order {
    padding: 20px 15px 40px;
    .digital-order-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #374151;
      margin-top: 10px;
      margin-bottom: 30px;
      .digital-order-title-left {
        font-size: 18px;
        color: #4b5563;
      }
      .digital-order-title-right {
        font-size: 14px;
        color: #1e40af;
      }
    }
    .digital-order-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 14px 12px;
    }
    .no-order {
        width: 100%;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #9ca3af;
        font-size: 14px;
    }
  }

  .digital-item {
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 14px;
    background-color: white;
    overflow: hidden;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    .digital-item-img {
      width: 100%;
      height: 160px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .no-item-img {
        width: 70%;
        height: 50%;
      }
    }
    .digital-item-info {
      padding: 10px 10px 10px;
      h3 {
        color: #1f2937;
        font-weight: 700;
        font-size: 14px;
      }
      p {
        margin: 4px 0 8px;
        font-size: 11px;
        color: #6b7280;
        min-height: 28px;
      }
    }
    .digital-item-tip {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: rgba(249, 115, 22, 0.9);
      color: white;
      padding: 3px 6px;
      border-radius: 5px;
      font-size: 10px;
    }
    .digital-item-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 4px;
    //   margin-bottom: 6px;
      .price {
        font-size: 12px;
        color: #1e40af;
      }
    }
    .buy-btn {
        background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
        margin-top: 4px;
        width: 100%;
        color: white;
        border: none;
        font-size: 12px;
        padding: 5px 5px;
        border-radius: 5px;
        cursor: pointer;
        flex-shrink: 0;
        &:hover {
            background-color: #1d4ed8;
        }
    }
  }
}
</style>